import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon, Button, Popup } from 'semantic-ui-react';

const NoPaddingButton = styled(Button)`
  &.ui.button {
    padding: 0.4em !important;
    background: none;
    margin-right: 0 !important;
  }
`;

const getIconName = (added, loading) => (loading ? 'spinner' : added ? 'heart' : 'heart outline');

const getPopupText = (disabled, disabledText, added) => {
  if (disabled) return disabledText;

  if (added) return 'ลบคณะในดวงใจ';

  return 'เพิ่มคณะในดวงใจ';
};

const HeartButton = ({ disabled, disabledText, added, loading, onClick }) => (
  <NoPaddingButton icon onClick={onClick} disabled={loading || disabled}>
    <Popup
      trigger={
        <Icon
          size="large"
          loading={loading}
          name={getIconName(added, loading)}
          color={added ? 'red' : 'grey'}
          disabled={disabled}
        />
      }
      on={'hover'}
      verticalOffset={0}
      horizontalOffset={7}
      hoverable={!added}
    >
      <Popup.Content>{getPopupText(disabled, disabledText, added)}</Popup.Content>
    </Popup>
  </NoPaddingButton>
);

HeartButton.defaultProps = {
  added: false,
  loading: false,
  disabledText: 'คณะในดวงใจครบจำนวนแล้ว',
  onClick: () => {},
};

export default HeartButton;
